import MagicBox from '../../../assets/images/magic_box.png';
import GalleryCar1 from '../../../assets/images/gallery_1.png';
import GalleryCar2 from '../../../assets/images/gallery_2.png';
import GalleryCar3 from '../../../assets/images/gallery_3.png';
import './Gallery.css';

const Gallery = () => {
  return (
    <div className='home__gallery'>
      <img src={MagicBox} className='home__gallery__logo' alt='gallery logo' />
      <label className='home__gallery__subtext'>
        <strong style={{fontSize:'22px'}}>For added excitement</strong><br/>
        We will be introducing : Random Mystery Boxes🎁. These may contain limited edition NFTs and upgrades, and are a true test of luck🍀. The Mystery Boxes🎁 drops will also be available on our marketplace🏪, so be sure to keep your eyes open for them ! 👀
      </label>
      <div className='home__gallery__image_box'>
        <img src={GalleryCar1} className='home__gallery__image' alt='gallery' />
        <img src={GalleryCar2} className='home__gallery__image' alt='gallery' />
        <img src={GalleryCar3} className='home__gallery__image' alt='gallery' />
      </div>
    </div>
  )
}

export default Gallery;